import { NgModule } from '@angular/core';
import { AddSpacesPipe } from './add-spaces.pipe';

@NgModule({
   declarations: [AddSpacesPipe],
   exports: [AddSpacesPipe],
})
export class AddSpacesPipeModule {}
